import { IsBoolean, IsDateString, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

export class CrearSesionDto {
  @IsString()
  @IsNotEmpty({ message: 'El nombre de la cuenta es obligatorio' })
  @MaxLength(200)
  nombre_cuenta: string;

  @IsOptional()
  @IsString()
  @MaxLength(150)
  banco?: string;

  @IsOptional()
  @IsString()
  @MaxLength(10)
  moneda?: string;

  @IsDateString({}, { message: 'periodo_desde debe ser una fecha válida (YYYY-MM-DD)' })
  periodo_desde: string;

  @IsDateString({}, { message: 'periodo_hasta debe ser una fecha válida (YYYY-MM-DD)' })
  periodo_hasta: string;

  // Si true, arrastra las partidas EN_TRANSITO de la última conciliación de esta cuenta.
  @IsOptional()
  @IsBoolean()
  arrastrar_en_transito?: boolean;
}
